import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/** Matches `prefix: "tw-"` in `tailwind.config.js` so conflicts resolve correctly. */
const twMerge = extendTailwindMerge({
  prefix: "tw-",
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
